import { Component } from '@angular/core';
import { THashComponent } from '../t-hash/t-hash.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-hash-element',
  templateUrl: './t-hash-element.component.html',
  styleUrls: ['../t-hash/t-hash.component.css','./t-hash-element.component.css']
})
export class THashElementComponent extends THashComponent {

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute, http);
    this.type="hashElement";
    this.text = this.get("hashElement");
   }
}
